import React, { useEffect, useState } from 'react'
import { Modal } from 'react-responsive-modal'
import 'react-responsive-modal/styles.css'

export default function ImageModal({ imgSrc, showImage, setShowImage }) {
  const [zoom, setZoom] = useState(false)
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  const toggleZoom = () => setZoom(!zoom)

  const handleCloseImage = () => {
    setShowImage(false)
    setZoom(false)
  }

  useEffect(() => {
    const mediaQuery = window.matchMedia('(pointer: coarse), (hover: none)')
    const updateTouchMode = () => setIsTouchDevice(mediaQuery.matches)

    updateTouchMode()
    mediaQuery.addEventListener('change', updateTouchMode)

    return () => {
      mediaQuery.removeEventListener('change', updateTouchMode)
    }
  }, [])

  return (
    <div>
      {imgSrc ? (
        <Modal
          open={showImage}
          onClose={handleCloseImage}
          center
          showCloseIcon={false}
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal'
          }}
          styles={{
            modal: {
              maxWidth: '90%',
              width: 'auto',
              padding: '20px'
            }
          }}
        >
          <button
            type="button"
            className="img-modal-close-button"
            onClick={handleCloseImage}
            aria-label="Cerrar imagen"
          >
            ×
          </button>
          <div className={`img-modal-image-frame${zoom ? ' img-modal-image-frame--zoomed' : ''}`}>
            <img
              src={imgSrc}
              alt="Imagen agregada"
              className={`img-modal-image${zoom ? ' img-modal-image--zoomed' : ''}`}
              onDoubleClick={isTouchDevice ? undefined : toggleZoom}
              onClick={isTouchDevice ? toggleZoom : undefined}
            />
          </div>
          <div className={`img-overlay-tooltip${isTouchDevice ? ' img-overlay-tooltip--mobile' : ''}`}>
            {isTouchDevice
              ? 'Toque la imagen para acercar o alejar'
              : 'Haga doble clic en la imagen para aumentar/disminuir el zoom'}
          </div>
        </Modal>
      ) : (
        <div>Imagen no disponible</div>
      )}
    </div>
  )
}
